<template>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg"  xmlns:xlink="http://www.w3.org/1999/xlink" :width="size" :height="size" viewBox="0 0 16 16">

        <g transform="translate(14 14.5) scale(0.8) rotate(180)" fill="white" >
            <g class="TQ_Animation_fadeInRight">
                <path fill="white" d="M2 13h2l5-5-5-5h-2l5 5z"></path>
                <path fill="white" d="M7 13h2l5-5-5-5h-2l5 5z"></path>
            </g>

        </g>

    </svg>
</template>

<script>
    export default {
        name: "si_arrowLeft",
        props:{
            size:{
                type: String,
                default: '48px'
            },
            direction:{
                type: String,
                default: 'rtl'
            }
        }
    }
</script>

<style scoped lang="scss">


</style>